/* @flow */
/* eslint-env es6,browser */

//set global variable needed for AOL(adtech) library
var _bidRequestConfig = window.bidRequestConfig || {};
var _dacBidRequestConfigs = window.dacBidRequestConfigs || [];
var _ADTECH = window.ADTECH || {};
window.bidRequestConfig = _bidRequestConfig;
window.dacBidRequestConfigs = _dacBidRequestConfigs;
window.ADTECH = _ADTECH;

import * as u from '../utils';
import bidbase from './bidbase';
import bm from '../bidmanager';

/**
 * @module bidders/adtech
 */
/**
 * @global
 * @typedef {object} adtechConfig
 * @description extends {@link hbConfig}
 * @property {string} bidKey
 * @property {string} id
 * @property {string} server
 */
/**
 * @description Implements functionality for adtech header bidding
 * @extends _bidbase
 * @requires module:utils
 */
class _adtechbid extends bidbase {
  _config: adtechConfig;
  _DefConfig: adtechConfig;
  _first: boolean;
  constructor() {
    super('adtech');
    this._first = true;
    this._DefConfig = u.extend(true, {}, this._DefConfig, {
      bidKey: 'aolbid',
      id: '',
      server: ''
    });
    this._config = u.extend(true, {}, this._DefConfig);
    this._mandatoryConfigs = ['script', 'id', 'server'];
    this._posId = 'alias';
    this._initCheck = {
      context: window.ADTECH,
      func: 'loadPubAd'
    };
  }

  /**
   * Initialize adtech variables
   * @returns {initStatus} - Pre-init status
   * @access private
   */
  _preInit(): initStatus {
    u.extend(true, _bidRequestConfig, {
      server: this._config.server,
      network: this._config.id,
      bidKey: this._config.bidKey,
      bidResponseTimeout: this._config.timeout
    });

    this._config.positions.forEach(v => {
      _dacBidRequestConfigs.push({
        placement: this._config.posTokenMap[v].placement,
        alias: this.getPosKey(v),
        adContainerId: this._config.posTokenMap[v].adContainerId,
        bidfloor: '0.1',
        secure: true
      });
    });
    return u.F_INITED;
  }

  /**
   * Process RTB bid response. Response Format:
   * _bidResponses[alias].fixedCpm - ecpm
   * _bidResponses[alias].api.data.seatbid[0].bid[0].adm - ad creative
   * @param {Array<string>} posList - array of positions
   * @param {Object.<string, hbPosData>} ret - Return data
   * @return {Object.<string, hbPosData>} - Return data
   * @access private
   */
  _processBidResponse(
    posList: Array<string>,
    ret: hbPartnerData
  ): hbPartnerData {
    var alias = '',
      res = {};
    this._first = false;
    posList.forEach(pos => {
      alias = this.getPosKey(pos);
      res = this._bidResponses[alias];
      if (
        res &&
        res.success &&
        u.isObject(res.api) &&
        this._isValidRTBResponse(res.api.data)
      ) {
        this._handleBidPosData(
          ret,
          pos,
          res.fixedCpm,
          alias,
          res.api.data.seatbid[0].bid[0].adm
        );
      }
    });
    return ret;
  }

  /**
   * get bids for given positions
   * @param {Array<string>} posList - HB position list
   * @param {Object.<string, hbPosData>} ret - return data
   * @return {Promise<Object.<string, hbPosData>>} - Promise
   * @access private
   */
  _getAds(posList: Array<string>, ret: hbPartnerData): Promise<hbPartnerData> {
    this._bidResponses = {};
    var bidPromise = new Promise(resolve => {
      // bid response callback
      _bidRequestConfig.onBidResponse = response => {
        this._bidResponses[response.alias] = response;
        if (posList.length === Object.keys(this._bidResponses).length) {
          resolve();
        }
      };
      //call loadPubAd for each position
      const loadAd = this._first ? _ADTECH.loadPubAd : _ADTECH.refreshPubAd;
      posList.map(v => this.getPosKey(v)).forEach(x => loadAd(x));
    });

    return new Promise(resolve => {
      Promise.race([
        bidPromise,
        u.getTimeoutPromise(this._config.timeout, this._name)
      ]).then(
        () => {
          resolve(this._processBidResponse(posList, ret));
          return ret;
        },
        msg => {
          u.logError(msg);
          resolve(this._processBidResponse(posList, ret));
        }
      );
    });
  }
}

//add bidder to bidmanager
let adtechbid = new _adtechbid();
bm.addBidder('adtech', adtechbid);
export default adtechbid;
